import {
  AlarmClock,
  Megaphone,
  Bell,
  Bot,
  CalendarDays,
  FileText,
  FolderOpen,
  LayoutDashboard,
  NotebookPen,
  ListChecks,
  Plug,
  Settings,
  Target,
  Users,
  Wallet,
  Workflow,
  type LucideIcon,
} from "lucide-react";
import { t } from "@shared/i18n";

export type NavItem = {
  id: string;
  label: string;
  to: string;
  icon: LucideIcon;
  /** Phase de la feuille de route dans laquelle le module est livré (null = disponible). */
  phase: number | null;
  description: string;
  shortcut?: string;
  /** Module désactivable par l'administration. */
  flag?: "automations" | "team" | "integrations" | "meetings" | "voice";
};

export const NAV: NavItem[] = [
  { id: "overview", label: t("Vue d'ensemble"), to: "/app", icon: LayoutDashboard, phase: null, description: t("Votre journée et votre activité en un coup d'œil."), shortcut: "G O" },
  { id: "coach", label: t("Coach IA"), to: "/app/coach", icon: Bot, phase: null, description: t("Votre Copilote conversationnel."), shortcut: "G C" },
  { id: "planning", label: t("Planification"), to: "/app/planning", icon: CalendarDays, phase: null, description: t("Calendrier, disponibilités et planification intelligente.") },
  { id: "tasks", label: t("Tâches et projets"), to: "/app/tasks", icon: ListChecks, phase: null, description: t("Tâches, projets, priorités et dépendances.") },
  { id: "finance", label: t("Finances"), to: "/app/finance", icon: Wallet, phase: null, description: t("Transactions, trésorerie et prévisionnel.") },
  { id: "documents", label: t("Documents"), to: "/app/documents", icon: FileText, phase: null, description: t("Devis, factures, propositions et modèles.") },
  { id: "reminders", label: t("Rappels"), to: "/app/reminders", icon: AlarmClock, phase: null, description: t("« Rappelle-moi de… » : à l'heure dite, sur tous vos appareils.") },
  { id: "marketing", label: t("Studio marketing"), to: "/app/marketing", icon: Megaphone, phase: null, description: t("Posts, publicités, client idéal, plan marketing : prêts en un clic.") },
  { id: "meetings", label: t("Réunions"), to: "/app/meetings", icon: NotebookPen, phase: null, flag: "meetings", description: t("Comptes rendus, décisions et actions à partir de vos notes ou de votre voix.") },
  { id: "files", label: t("Fichiers et connaissances"), to: "/app/files", icon: FolderOpen, phase: null, description: t("Stockage sécurisé et base de connaissances.") },
  { id: "automations", label: t("Automatisations"), to: "/app/automations", icon: Workflow, phase: null, flag: "automations", description: t("Workflows avec déclencheurs, conditions et validations.") },
  { id: "goals", label: t("Objectifs et performances"), to: "/app/goals", icon: Target, phase: null, description: t("Objectifs, jalons et progression transparente.") },
  { id: "team", label: t("Équipe"), to: "/app/team", icon: Users, phase: null, flag: "team", description: t("Espace partagé, rôles et permissions.") },
  { id: "integrations", label: t("Intégrations"), to: "/app/integrations", icon: Plug, phase: null, flag: "integrations", description: t("Google, Microsoft, Slack, Notion, Stripe…") },
  { id: "notifications", label: t("Notifications"), to: "/app/notifications", icon: Bell, phase: null, description: t("Rappels, alertes et activité.") },
  { id: "settings", label: t("Paramètres"), to: "/app/settings", icon: Settings, phase: null, description: t("Profil, interface, IA, mémoire et confidentialité."), shortcut: "G S" },
];

/** Accès rapides de la barre de navigation mobile. */
export const MOBILE_PRIMARY = ["overview", "coach", "tasks", "finance"];
